import { ChangeEvent, ReactNode } from 'react';

import { useUniqueId } from 'utils/hooks';

import {
  TabSwitcherTabInput,
  TabSwitcherTabLabel,
} from './TabSwitcherTab.styles';

type Props = {
  name: string;
  isSelected: boolean;
  children: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  qaId?: string;
};

export function TabSwitcherTab({
  name,
  isSelected,
  children,
  onChange,
  qaId,
}: Props) {
  const id = useUniqueId({ prefix: 'tab-switcher-tab' });

  return (
    <>
      <TabSwitcherTabInput
        id={id}
        className="visibility"
        type="radio"
        name={name}
        checked={isSelected}
        onChange={onChange}
      />

      <TabSwitcherTabLabel htmlFor={id} data-qa-id={qaId}>
        {children}
      </TabSwitcherTabLabel>
    </>
  );
}
